module.exports = __webpack_public_path__ + "img/welcome.019f725f.webp";